module.exports = __webpack_public_path__ + "static/media/money-icon-blue.ab80dd43.svg";